// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import * as GuildMemberCommands from '@app/features/member/commands/GuildMemberCommands';
import {Logger} from '@app/features/platform/utils/AppLogger';
import * as ToastCommands from '@app/features/ui/commands/ToastCommands';
import type {User} from '@app/features/user/models/User';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

const logger = new Logger('KickMemberModal');
export const KickMemberModal: React.FC<{guildId: string; targetUser: User}> = observer(({guildId, targetUser}) => {
	const {t} = useLingui();
	const handleKick = async () => {
		try {
			await GuildMemberCommands.kick(guildId, targetUser.id);
			ToastCommands.createToast({
				type: 'success',
				children: <Trans>Successfully kicked {targetUser.tag} from the community</Trans>,
			});
		} catch (error) {
			logger.error('Failed to kick member:', error);
			ToastCommands.createToast({
				type: 'error',
				children: <Trans>Failed to kick member. Please try again.</Trans>,
			});
		}
	};
	return (
		<ConfirmModal
			title={t`Kick Member`}
			description={
				<div>
					<Trans>
						Are you sure you want to kick <strong>{targetUser.tag}</strong> from the community? They will be able to
						rejoin with a new invite.
					</Trans>
				</div>
			}
			primaryText={t`Kick`}
			primaryVariant="danger-primary"
			secondaryText={t`Cancel`}
			onPrimary={handleKick}
		/>
	);
});
